export const groupBy = (objectArray, property, property2 = null) => {
  return objectArray.reduce((acc, obj) => {
    const key = property2 ? obj[property][property2] : obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
}